import { ROUTES } from '@/constants/routes'

export const quickLinks = [
  { label: 'About Kandake', path: ROUTES.ABOUT },
  { label: "Women's Health", path: ROUTES.WOMENS_HEALTH },
  { label: 'Our Services', path: ROUTES.SERVICES },
  { label: 'Contact Us', path: ROUTES.CONTACT },
]
